<template>
  <div>
    <dashboard-header :text="$t('sosCase.caption')"/>

    <v-card
        elevation="0"
        class="card-border-10">

      <div class="d-flex pt-10 px-10">
        <div class="ms-auto me-4 mt-2 text-18px">{{ $t("base.filterByDepartment") }}</div>

        <div class="w-50">
          <v-select
              :loading="filterLoading"
              v-model="selectedFilter"
              :items="listFilter"
              :placeholder="$t('employee.selectDepartment')"
              v-on:change="customFilter"
              item-text="name"
              small-chips
              chips
              deletable-chips
              return-object
              dense
              outlined>

          </v-select>
        </div>

        <v-btn
            v-if="isCreate"
            elevation="0"
            class="no-uppercase btn-custom-primary ml-5"
            @click="addItem">
          <b-img
              class="mr-2"
              :src="require('@/assets/images/ic-plus.svg')"
              width="16"
              height="16"
          />
          {{ $t("base.create") }}
        </v-btn>
      </div>

      <d-table
          class="px-10"
          hideSearch
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
      />
    </v-card>

  </div>
</template>

<script>
import {SOS_TYPE, SPECIAL_SOS_TYPE, TYPE_FORMAT_TIME} from "../../config/constant";
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
      filterLoading: false,
      labelFilterTable: i18n.t("base.filterByDepartment"),
      firstFilterTableLabel: i18n.t("base.allDepartments"),
      listFilter: [],
      selectedFilter: null,
      isCreate: true,
      isEdit: true,
      isDelete: true,
      listSpecialSosType: [
        {name: 'Thường', value: 1},
        {name: 'Code Blue', value: 2},
        {name: 'Bạo hành', value: 3},
        {name: '', value: undefined},
      ],
    };
  },
  computed: {
    fields() {
      return [
        {value: "name", text: i18n.t("sosCase.source"), sortable: false},
        {value: "specialTypeName", text: i18n.t("sosCase.selectSosCaseType"), sortable: false},
        {value: "sosType", text: i18n.t("sosCase.sosType"), sortable: false},
        {value: "targetsInfo", text: i18n.t("sosCase.targets"), sortable: false},
        {value: "sosMessage", text: i18n.t("sosCase.sosMessage"), sortable: false},
        {value: "actions", sortable: false}
      ];
    },
  },
  mounted() {
    this.onTab()
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams);
      this.getListFilter();
    },
    async getItems(optionParams) {
      if (!optionParams) return
      optionParams.departmentId = this.selectedFilter ? this.selectedFilter.departmentId : null
      this.optionParams = optionParams
      let res = await this.get(API2.SOS_CASE, optionParams)
      if (!res) return
      this.items = res.data
      this.totalRows = res.total
      for (let value of res.data) {
        value.name = value.sourceInfo && value.sourceInfo.name ? value.sourceInfo.name : ""
        value.specialTypeName = this.listSpecialSosType.find(i => i?.value === value.specialType)?.name || ""
        value.sosType = value.sosTypeInfo && value.sosTypeInfo.name ? this.shortenText(value.sosTypeInfo.name, 25) : ""
        value.targetsInfo = this.checkTargets(value)
        // Priority: Live SosMessage.message > cached description > empty
        const messageContent = value.description || '';
        value.sosMessage = messageContent ? (messageContent.length > 50 ? messageContent.substring(0, 50) + '...' : messageContent) : ''
        value.updatedAt = this.formatDate(value.updatedAt, TYPE_FORMAT_TIME.DD_MM_YYYY)
      }
    },
    addItem() {
      this.openTab(2)
    },
    editItem(item) {
      this.openTab(2, item)
    },
    onItemTableClick(item) {
      this.openTab(1, item)
    },
    onDeleteContent() {
      return i18n.t("ui.confirmDataDelSosCase")
    },
    async deleteItem(item) {
      // Check if this is a Code Blue or Abuse case
      if (item.specialType === SPECIAL_SOS_TYPE.CODE_BLUE || item.specialType === SPECIAL_SOS_TYPE.VIOLENCE) {
        this.showToast("error", i18n.t("base.notification"), this.$t("common.cannotDeleteSpecialSosCase"));
        return;
      }

      let res = await this.delete(API2.SOS_CASE, {path: item.sosCaseId})
      if (res) {
        this.showToast("success", i18n.t("base.notification"), `${i18n.t("base.deleteSuccessful")}`)
        this.getItems(this.optionParams);
      }
    },
    async getListFilter() {
      let res = await this.get(API2.DEPARTMENT, null, "filterLoading")
      this.listFilter = res.data?.map(i => ({... i, name: this.shortenText(i.name, 40)}));
    },
    customFilter() {
      this.getItems(this.optionParams)
    },
    checkTargets(value) {
      if (value.targetsInfo) {
        if (value.sosTypeInfo.sosTypeId === SOS_TYPE.OUT_THE_HOSPITAL) {
          return value.targetsInfo.map(_deparment => {
            return {
              ..._deparment,
              name: `${i18n.t("sosCase.hospital")}: ${
                  this.shortenText(_deparment.Hospital.name, 25)
              }`
            };
          });
        }
        let result = Array.isArray(value.targetsInfo)
            ? value.targetsInfo?.map(i => ({...i, name: this.shortenText(i?.name, 25)}))
            : [{...value.targetsInfo, name: this.shortenText(value.targetsInfo?.name, 25)}];

        // remove duplicate
        result = Array.from(
            new Set(result.map(department => department.departmentId))
        ).map(departmentId => {
          return result.find(
              department => department.departmentId === departmentId
          );
        });

        // remove source
        const _targets = JSON.parse(value.targets);
        return result.filter(value =>
            _targets.includes(value.departmentId)
        );
      }

      return "";
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  }
}
;
</script>

<style></style>
